<script lang="ts">
  import { Tooltip } from 'sveltestrap';
  
  export let text="";
  function createUniqueId() {
    return Math.random().toString(36).substr(2, 9);
  }
  let id = createUniqueId();
  
  export let placement="right";
  export let maxWidth=250;
</script>


<span id="tooltip-{id}"><slot /></span>
<Tooltip target="tooltip-{id}" bind:placement class="custom-tooltip" style="--bs-tooltip-max-width:{maxWidth}px;">
	{text}
</Tooltip>

